var map = {
	"./certificate-preview": 1,
	"./certificate-preview.png": 1,
	"./default-avatar": 2,
	"./default-avatar.png": 2,
	"./ioc-logo": 3,
	"./ioc-logo-shield": 4,
	"./ioc-logo-shield.png": 4,
	"./ioc-logo.png": 3,
	"./linkedin": 5,
	"./linkedin.png": 5,
	"./stars": 6,
	"./stars.svg": 6,
	"./transcript-icon": 7,
	"./transcript-icon.svg": 7
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;